export const LOCALE_STORAGE_KEY = 'ONLINE_QT_LOCALE';

/**
 * SessionStorage key used to flag that the store should be reset on next app initialization.
 * Set when user navigates away from the app via return URL.
 */
export const STORE_RESET_KEY = 'ONLINE_QT_STORE_RESET';

export const COMPANY_STORAGE_KEY = 'ONLINE_QT_COMPANY';
